import React, { useState } from 'react'
import sessionData from '@bikemap/js/services/sessionData'
import { route as routeApi } from '@bikemap/js/api'
import { handleUnauthenticatedRouteFavor } from '@bikemap/js/integrations/routes'
import { FavoriteInfo } from '@bikemap/components/FavoriteInfo'

export const FavoriteInfoContainer = ({ route }) => {
    const [isFavorite, setIsFavorite] = useState(route.isFavorite)
    const [favoriteCount, setFavoriteCount] = useState(route.favoriteCount)

    const handleClick = async () => {
        if (await sessionData.isLoggedIn()) {
            if (isFavorite) {
                routeApi.unfavor(route.id)
            } else {
                routeApi.favor(route.id)
            }
            setFavoriteCount(favoriteCount + (isFavorite ? -1 : 1))
            setIsFavorite(!isFavorite)
        } else {
            handleUnauthenticatedRouteFavor()
        }
    }

    return <FavoriteInfo isFavorite={isFavorite} favoriteCount={favoriteCount} onClick={handleClick} />
}
